import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index/index'
import API from '@/views/api/index'
import allAPI from '@/views/api/allApi'
import apiDetail from '@/views/api/apiDetail'
import charge from '@/views/charge/index'
import center from '@/views/center/index'
import Center from '@/views/center/index'
import case1 from '@/views/center/caseChild/case1'
import case2 from '@/views/center/caseChild/case2'
import case3 from '@/views/center/caseChild/case3'
import case4 from '@/views/center/caseChild/case4'
import case5 from '@/views/center/caseChild/case5'
import AboutUs from '@/views/aboutUs/index'
import Consulting from '@/views/consulting/index'
import Contact from '@/views/contact/index'
import item1 from '@/views/aboutUs/caseChild/case1'
import item2 from '@/views/aboutUs/caseChild/case2'
import item3 from '@/views/aboutUs/caseChild/case3'
import item4 from '@/views/aboutUs/caseChild/case4'
// 站点访问前缀：由 .env 的 VUE_APP_BASE_PATH 提供（根路径部署为空串）
import { BASE_PATH } from '@/config'
// import Test from '@/components/index'

Vue.use(Router)

export default new Router({
  // history 模式：URL 为 /api、/aboutUs/case1 这类真实路径，便于搜索引擎抓取与收录；
  // 旧的 #/api 形式由 index.html 中的兼容脚本自动 301 式跳转到新地址。
  // 部署要求：服务端需把未命中的路径回退到 index.html（构建产物已为每个路由预渲染静态页，
  // 纯静态托管下直接访问同样可用），nginx 配置见 docs/seo.md。
  mode: 'history',
  // 部署前缀：例如把站点挂在 https://host/xxx/ 下时，.env 里配 VUE_APP_BASE_PATH=/xxx
  base: BASE_PATH || '/',
  linkActiveClass:'active',
  linkExactActiveClass:'active',
  // 跳转返回顶部
  scrollBehavior(to,from,saveTop){
    if(saveTop){
      return saveTop;
    }else{
      return {x:0,y:0}
    }
  },
  routes: [
	// {
	//   path: '/',
	//   name: 'test',
	//   component: Test
	// },
    {
      path: '/',
      name: 'index',
      component: index
    },
	{
	  path: '/api',
	  name: 'api',
	  component: API
	},
	{
	  path: '/allApi',
	  name: 'allApi',
	  component: allAPI
	},
	{
	  path: '/apiDetail',
	  name: 'apiDetail',
	  component: apiDetail
	},
	{
		path: '/charge',
		name: 'charge',
		component: charge
	},
	{
		path: '/consulting',
		name: 'consulting',
		component: Consulting
	},
	{
		path: '/contact',
		name: 'contact',
		component: Contact
	},
	{
	  path: '/center',
	  name: 'center',
	  component: center
	},
    {
      // 原在线测试独立页已并入「数据产品」页的 03 区块；保留该路径做兼容跳转，
      // dimId / id 等查询参数原样透传，页面会据此选中接口并滚动到测试区
      path: '/apiTest',
      name: 'apiTest',
      redirect: to => ({ path: '/api', query: to.query })
    },
	{
		path: '/center',
		name: 'center',
		component: Center,
		redirect: '/center/case1',
		children:[
		  {
		    path:'/center/case1',
		    component:case1
		  },
		  {
		    path:'/center/case2',
		    component:case2,
		  },
		  {
		    path:'/center/case3',
		    component:case3,
			name: 'myApi'
		  },
		  {
		    path:'/center/case4',
		    component:case4,
		  },
		  {
		    path:'/center/case5',
		    component:case5,
		  }
		]
	},
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: AboutUs,
		redirect: '/aboutUs/case1',
		children:[
		  {
		    path:'/aboutUs/case1',
		    component:item1,
		  },
		  {
		    path:'/aboutUs/case2',
		    component:item2,
		  },
		  {
		    path:'/aboutUs/case3',
		    component:item3,
		  },
		  {
		    path:'/aboutUs/case4',
		    component:item4,
		  }
		]
	}

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js